import { render, staticRenderFns } from "./ct-department.vue?vue&type=template&id=23dddb93&scoped=true"
import script from "./ct-department.vue?vue&type=script&lang=js"
export * from "./ct-department.vue?vue&type=script&lang=js"
import style0 from "./ct-department.vue?vue&type=style&index=0&id=23dddb93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dddb93",
  null
  
)

export default component.exports